import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 26 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 32\" id=\"icon-download\"><g id=\"icon-download_Layer_2\" data-name=\"Layer 2\"><g id=\"icon-download_Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M24.23,6.23A7.09,7.09,0,0,1,26,10H16V0a7.09,7.09,0,0,1,3.77,1.74ZM14,12V0H2.5A2.51,2.51,0,0,0,0,2.5v27A2.51,2.51,0,0,0,2.5,32h21A2.51,2.51,0,0,0,26,29.5V12ZM13,30,5,22h5V16h6v6h5Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol